import { RadixDialog } from '@/components/RadixDialog';
import { useGlobalState, usePreventBodyScroll } from '@/hooks';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import { MobilePopupHeader } from '../../MobilePopupHeader';
import { CloseIcon, CloseIconWrapper, PopupContainer } from './SimpleCenter.styles';
import { HeroImage } from './components/HeroImage';
import { PopupContent } from './components/PopupContent';

export const SimpleCenter: React.FC<IPmtOnboardingPopup & { onCloseOnboardingPopUp: () => void }> = (props) => {
  const { heroImage, loginByEmail, onCloseOnboardingPopUp } = props;
  const { showPMTPopUp } = useGlobalState();
  const hasHeroImage = !!heroImage?.url;

  usePreventBodyScroll(showPMTPopUp);

  return (
    <RadixDialog open={showPMTPopUp} onOpenChange={onCloseOnboardingPopUp}>
      <PopupContainer hasHeroImage={hasHeroImage}>
        {hasHeroImage && <MobilePopupHeader onClose={onCloseOnboardingPopUp} />}
        <CloseIconWrapper hasHeroImage={hasHeroImage}>
          <CloseIcon />
        </CloseIconWrapper>
        <HeroImage heroImage={heroImage} loginByEmail={loginByEmail} />
        <PopupContent {...props} />
      </PopupContainer>
    </RadixDialog>
  );
};
